import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isValid as dateIsValid } from 'date-fns';
import { calendarMonthYearIdentifier, asISOformat, getToday } from 'utils/date-formatter';
import { MonthRange } from './MonthRange';
import { DateSelector } from './DateSelector';
import { checkSelectedOffsets, scrollSection } from './date-picker-utils';
import './DatePicker.scss';

export const DatePicker = (props) => {
  const {
    CalendarData: { Years, SelectedDate: defaultSelectedDate },
    dateClickHandler = () => {},
    firstDateIsSelected,
    componentClass = '',
  } = props;
  const [selectedDate, setSelectedDate] = useState(firstDateIsSelected || defaultSelectedDate);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [scrollAmount, setScrollAmount] = useState(0);
  const monthSwiperWrapRef = useRef();
  const monthSwiperRef = useRef();
  const dateSwiperWrapRef = useRef();
  const dateSwiperRef = useRef();
  const calendarRef = useRef();

  const setDateHandler = (date) => {
    setSelectedDate(asISOformat(date));

    /**
     * Setting the startDate on context provider changes the filterSetModel
     * and calls getFilters API
     */
    dateClickHandler(asISOformat(date));
  };

  const setMonthHandler = (monthIdentifier) => {
    setSelectedMonth(monthIdentifier);

    const monthDisplay = document.getElementById(`${monthIdentifier}`);
    scrollSection({
      swiperType: 'date',
      swiperRef: dateSwiperRef.current,
      position: monthDisplay.offsetLeft,
      scrollAmount,
    });
  };

  const displayCurrent = () => {
    if (!selectedDate) return;

    const currentScrollAmount = Math.floor((calendarRef.current.offsetWidth * 65) / 100);
    setScrollAmount(Math.floor(currentScrollAmount));

    const updatedSelectedMonth = dateIsValid(Date.parse(selectedDate))
      ? calendarMonthYearIdentifier(selectedDate)
      : calendarMonthYearIdentifier(getToday());
    setSelectedMonth(updatedSelectedMonth);

    checkSelectedOffsets({
      swiperType: 'month',
      swiperRef: monthSwiperRef.current,
      alignToLeft: true,
      scrollAmount: currentScrollAmount,
      componentClass,
    });

    checkSelectedOffsets({
      swiperType: 'date',
      swiperRef: dateSwiperRef.current,
      alignToLeft: true,
      scrollAmount: currentScrollAmount,
      componentClass,
    });
  };

  useEffect(() => {
    displayCurrent();
  }, []);

  return (
    <div className="bg-light-putty">
      <div className="calendar-wrap">
        <div className="container">
          <div className="calendar" ref={calendarRef}>
            <MonthRange
              years={Years}
              setMonthHandler={setMonthHandler}
              selectedMonth={selectedMonth}
              monthSwiperWrapRef={monthSwiperWrapRef}
              monthSwiperRef={monthSwiperRef}
              calendarRef={calendarRef}
            />
            <DateSelector
              years={Years}
              selectedDate={selectedDate}
              setDateHandler={setDateHandler}
              dateSwiperWrapRef={dateSwiperWrapRef}
              dateSwiperRef={dateSwiperRef}
              calendarRef={calendarRef}
              setSelectedMonth={setSelectedMonth}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

DatePicker.propTypes = {
  CalendarData: PropTypes.object,
  dateClickHandler: PropTypes.func,
  firstDateIsSelected: PropTypes.string,
  componentClass: PropTypes.string,
};
